module.exports = __webpack_public_path__ + "img/ic_wusousuo.ae4488f7.png";